import React, { useState } from 'react';

const VideoWithModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const openModal = () => {
    setIsModalOpen(true);
  };
  
  const closeModal = () => {
    setIsModalOpen(false);
  };
  
  return (
    <div className="w-full relative mb-8 lg:mb-0">
      <div className="relative">
        <img
          src="/home-8/testimonials/1.png"
          alt="Students learning"
          className="w-full h-auto rounded-lg"
        />

        {/* Play Button */}
        <div className="absolute inset-0 flex items-center justify-center">
          <button
            onClick={openModal}
            className="flex items-center justify-center bg-white dark:bg-gray-800 w-16 h-16 md:w-20 md:h-20 rounded-full shadow-lg hover:scale-110 transition-transform duration-300"
            aria-label="Watch video"
          >
            <svg className="w-8 h-8 md:w-10 md:h-10 text-red-500" fill="currentColor" viewBox="0 0 24 24">
              <path d="M8 5v14l11-7z" />
            </svg>
          </button>
        </div>
      </div>
      
      {/* Modal Video */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75">
          <div className="relative w-full max-w-4xl mx-4">
            <button
              onClick={closeModal}
              className="absolute -top-10 right-0 text-white text-xl p-2"
              aria-label="Close video"
            >
              ✕
            </button>
            <div className="relative aspect-w-16 aspect-h-9">
              <video
                className="w-full h-auto rounded-lg"
                controls
                autoPlay
                src="https://docs.material-tailwind.com/demo.mp4"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoWithModal;